import { HmfAlertBannerComponent, HmfButtonComponent, HmfRadioComponent, HmfRadioGroupComponent } from '@dsg-tech/homefield-angular';

import { CommonModule } from '@angular/common';
import { ErewardOptInComponent } from './ereward-opt-in.component';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
	declarations: [
		ErewardOptInComponent
	],
	exports: [
		ErewardOptInComponent
	],
	imports: [
		CommonModule,
		HmfAlertBannerComponent,
		HmfButtonComponent,
		HmfRadioComponent,
		HmfRadioGroupComponent,
		ReactiveFormsModule
	]
})
export class ErewardOptInModule {}
